import Lottie from 'lottie-react';

import lottieInsurance from '../jsons/insurance.json';

const LottieInsurance = props => {
  return <Lottie animationData={lottieInsurance} loop={false} {...props} />;
};

export default LottieInsurance;
